
import Vue from 'vue'

export default Vue.extend({

  props: {
    data: {
      type: Object as () => {
        existed: boolean
        isReefer: boolean
        is45Foot: boolean
        isTank: boolean
        isFlatRack: boolean
        isOpenTop: boolean
        isPlatform: boolean
        color: string
    },
      
      default: () => ({
        existed: true,
        isReefer: true,
        is45Foot: true,
        isTank: false,
        isFlatRack: false,
        isOpenTop: false,
        isPlatform: false,
        isEmpty: false
      }),


    }
  },
  data() {
    return {
      abc: ''
    }
  },

})
